import { computed } from 'vue'

import type { Lists } from '@brighterly/lib-core-types/lists/interfaces'
import type { ComputedRef } from 'vue'

import { useListsStore } from '@stores/lists'

interface ListsReturn {
  lists: ComputedRef<Lists | null>
  timeSlots: ComputedRef<string[] | null>
  hasData: ComputedRef<boolean>
}
export const useLists = (): ListsReturn => {
  const store = useListsStore()

  store.hydrateFromStorage()
  void store.ensure({ background: true })
  void store.ensureTimeSlots({ background: true }) // TODO: separate time slots store

  return {
    lists: computed(() => store.lists),
    timeSlots: computed(() => store.timeSlots),
    hasData: computed(() => store.hasData),
  }
}
